import { render, staticRenderFns } from "./BoryNoveBloky.vue?vue&type=template&id=d7b95886&scoped=true"
import script from "./BoryNoveBloky.vue?vue&type=script&lang=js"
export * from "./BoryNoveBloky.vue?vue&type=script&lang=js"
import style0 from "./BoryNoveBloky.vue?vue&type=style&index=0&id=d7b95886&prod&lang=sass&scoped=true"
import style1 from "./BoryNoveBloky.vue?vue&type=style&index=1&id=d7b95886&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b95886",
  null
  
)

export default component.exports